import { cn } from "../../utils/cn";
import { focusStyles } from "../../utils/focus-styles.ts";

interface CloseButtonProps {
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  "aria-label"?: string;
}

// The focus ring is a box-shadow (drawn outside the box) rather than a border, so focusing the
// button never changes its size — no layout shift, and an adjacent scrollbar cannot clip it.
const buttonStyles =
  "inline-flex items-center justify-center p-1 " +
  "text-loch " +
  "hover:bg-loch-50 " +
  "active:bg-loch-100 " +
  focusStyles;

export const CloseButton = ({
  onClick,
  className,
  iconClassName,
  "aria-label": ariaLabel = "Close",
}: CloseButtonProps) => {
  return (
    <button type="button" className={cn(buttonStyles, className)} onClick={onClick} aria-label={ariaLabel}>
      <i
        className={cn(
          "fa-sharp fa-regular fa-xmark text-[20px] size-5 flex items-center justify-center",
          iconClassName,
        )}
        aria-hidden="true"
      />
    </button>
  );
};
